<template>
  <div class="card-todo">
    <div class="d-flex">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" fill="white" />
        <path
          d="M15.6341 9.03798H28.6014V10.8905H15.6341V9.03798ZM6.37163 11.4369L3.97266 9.03798L2.66666 10.344L6.37163 14.0489L13.7816 6.63901L12.4756 5.33301L6.37163 11.4369ZM15.6341 22.0054H28.6014V23.8579H15.6341V22.0054ZM6.37163 24.4043L3.97266 22.0054L2.66666 23.3114L6.37163 27.0163L13.7816 19.6064L12.4756 18.3004L6.37163 24.4043Z"
          fill="#A9182A"
        />
      </svg>
      <h3 class="pb-2 text-red mx-2">To Do List</h3>
    </div>

    <div
      v-if="todoList.length === 0"
      class="d-flex align-center justify-center pa-10"
    >
      <span>ไม่พบข้อมูล</span>
    </div>

    <div v-else class="d-flex justify-center">
      <div class="todo-list-table">
        <div class="todo-list-table--header">
          <section style="flex-basis: 100px">
            <span>#</span>
          </section>
          <section style="flex-basis: 150px">
            <span>รายละเอียดงาน</span>
          </section>
          <section style="flex-basis: 150px">
            <span>ประเภทงาน</span>
          </section>
          <section style="flex-basis: 150px">
            <span>กำหนดเสร็จ</span>
          </section>
          <section style="flex-basis: 150px">
            <span>ประเภทการสร้าง</span>
          </section>
          <section style="flex-basis: 150px">
            <span>Status</span>
          </section>
          <section style="flex-basis: 100px">
            <span>Preview</span>
          </section>
        </div>

        <div
          v-for="(item, index) in todoList"
          :key="item.todo_id"
          class="todo-list-table--body"
          :style="{ background: index % 2 === 0 ? '#fff' : '#F8F8F8' }"
        >
          <section
            title="#"
            style="flex-basis: 100px"
            class="d-flex align-center justify-center"
          >
            <VisitTodoFormDialog
              v-if="item.status_txt === 'ยังไม่ได้ทำ'"
              mode="create"
              :data="item"
              :bpDetail="bpDetail"
              @closeDialog="getTodoList()"
            >
              <template #activate="{ openDialog }">
                <div class="checkbox--empty" @click="openDialog"></div>
              </template>
            </VisitTodoFormDialog>
            <div v-if="item.status_txt === 'ทำแล้ว'" class="checkbox--check">
              <v-icon color="#fff">mdi-check</v-icon>
            </div>
            <div v-if="item.status_txt === 'ไม่ได้ทำ'" class="checkbox--close">
              <v-icon color="#fff">mdi-close</v-icon>
            </div>
          </section>
          <section
            title="รายละเอียดงาน"
            style="flex-basis: 150px"
            class="d-flex align-center"
          >
            <div class="pa-2">
              <span>{{ item.detail || '-' }}</span>
            </div>
          </section>
          <section
            title="ประเภทงาน"
            style="flex-basis: 150px"
            class="d-flex align-center justify-center flex-column"
          >
            <span>{{ item.task_type_name || '-' }}</span>
            <div v-if="item.winloss === '1'" class="task-type--win">Win</div>
            <div v-if="item.winloss === '2'" class="task-type--loss">Loss</div>
          </section>
          <section
            title="กำหนดเสร็จ"
            style="flex-basis: 150px"
            class="d-flex align-center justify-center"
          >
            <span>{{ item.due_date || '-' }}</span>
          </section>
          <section
            title="ประเภทการสร้าง"
            style="flex-basis: 150px"
            class="d-flex align-center justify-center"
          >
            <span>{{ item.plan_by_txt || '-' }}</span>
          </section>
          <section
            title="Status"
            style="flex-basis: 150px"
            class="d-flex align-center justify-center"
          >
            <div
              v-if="item.status_txt === 'ยังไม่ได้ทำ'"
              class="status-box--yellow"
            >
              ยังไม่ได้ทำ
            </div>
            <div v-if="item.status_txt === 'ทำแล้ว'" class="status-box--green">
              ทำแล้ว
            </div>
            <div v-if="item.status_txt === 'ไม่ได้ทำ'" class="status-box--red">
              ไม่ได้ทำ
            </div>
          </section>

          <section
            title="Preview"
            style="flex-basis: 100px"
            class="d-flex align-center justify-center"
          >
            <div
              v-if="item.status_txt === 'ยังไม่ได้ทำ'"
              class="preview-icon--disabled"
            >
              <v-icon color="#BFBFBF">mdi-eye</v-icon>
            </div>
            <VisitTodoFormDialog
              v-else
              mode="show"
              :data="item"
              :bpDetail="bpDetail"
            >
              <template #activate="{ openDialog }">
                <div class="preview-icon" @click="openDialog">
                  <v-icon color="#0068C9">mdi-eye</v-icon>
                </div>
              </template>
            </VisitTodoFormDialog>
          </section>
        </div>
      </div>
    </div>

    <div v-if="todoList.length > 0" class="my-5">
      <v-pagination
        v-model="page"
        :length="pageTotal"
        color="#a9182a"
        circle
        @input="getTodoList()"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import VisitTodoFormDialog from './VisitTodoFormDialog.vue'

export default {
  components: {
    VisitTodoFormDialog,
  },
  props: {
    bpDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      todoList: [],
      page: 1,
      limit: 10,
      total: 0,
      pageTotal: 0,
    }
  },
  mounted() {
    this.getTodoList()
  },
  methods: {
    async getTodoList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPI}/visit/getTodoList`,
          {
            page: this.page,
            limit: this.limit,
            customer_id: this.$route.params.customerID,
          },
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.todoList = res.data.items.list
          this.pageTotal = res.data.items.page.total
          this.total = res.data.items.page.total_row
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-todo {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
}

.todo-list-table {
  overflow-x: auto;
  border-radius: 8px;

  &--header {
    display: flex;
    width: 950px;
    background: #000;
    color: #fff;
    font-size: 14px;

    & section {
      height: 52px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    & section:not(:last-child) {
      border-right: 1px solid #484848;
    }
  }
  &--body {
    display: flex;
    width: 950px;
    font-size: 14px;

    & section {
      min-height: 70px;
      flex-shrink: 0;
    }
  }
}

.checkbox {
  border-radius: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &--empty {
    @extend .checkbox;
    border: 1px solid #4a90e2;
    background: #fff;
  }
  &--check {
    @extend .checkbox;
    border: 1px solid #4a90e2;
    background: #4a90e2;
  }
  &--close {
    @extend .checkbox;
    border: 1px solid #a9182a;
    background: #a9182a;
  }
}

.status-box {
  border-radius: 8px;
  color: #fff;
  padding: 0.5rem 1rem;
  &--green {
    @extend .status-box;
    background: #259b12;
  }
  &--yellow {
    @extend .status-box;
    background: #eab500;
  }
  &--red {
    background: #a50200;
    @extend .status-box;
  }
}

.preview-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid #b5cee6;
  background: #e3f5ff;

  &--disabled {
    @extend .preview-icon;
    border: 1px solid #e0e0e0;
    background: #f3f3f3;
  }
}

.task-type {
  border-radius: 4px;
  padding: 2px 12px;
  font-size: 14px;
  font-weight: 500;
  &--win {
    @extend .task-type;
    background: #edf8ec;
    color: #259b12;
  }
  &--loss {
    @extend .task-type;
    background: #feeced;
    color: #ff5252;
  }
}
</style>
